<template>
  <div class="button-wrap">
    <button type="button" class="app-button" :class="{'app-button--white': theme === 'white', 'app-button--wide': wide === true}" @click="onAppBtnClick">{{msg}}</button>
  </div>  
</template>

<script>
export default {
  name: "Button",
  props: {
    msg: {
      type: String,
      required: true,
      default: "",
    },
    theme: {
      type: String,
      required: false,
      default: "dark",
    },
    wide: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onAppBtnClick() {
      this.$emit("btnClick");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.button-wrap {
  margin: 30px auto;
}
.app-button {
  text-transform: uppercase;
  display: block;
  margin: 0 auto;
  width: 100%;
  background-color: transparent;
  color: $white-color;
  border: 1px solid $light-gray-color;
  font-size: 1.4rem;
  padding: 10px;
  width: 100%;
  max-width: 250px;
}
.app-button:hover {
  background-color: $card-hover-color;
}
.app-button--white {
  background-color: $white-color;
  color: $black-color;
}
.app-button--white:hover {
  background-color: $white-color;
  color: $black-color;
}
.app-button--wide {
  max-width: 100%;
}
</style>
